:host {
  --md-typography--default-color: var(--md-color--spirits--900);
  --md-typography--font-family: var(--md-font-family--text-regular);
  --md-typography--font-size: var(--md-font-size--body1);
  --md-typography--line-height: var(--md-line-height--body1);
  --md-typography--letter-spacing: var(--md-letter-spacing--sm);
  --md-typography--alignment: left;
}

:host(.md-display--h1),
:host(.md-display--h2),
:host(.md-display--h3),
:host(.md-display--h4),
:host(.md-display--h5),
:host(.md-display--h6),
:host(.md-display--p),
:host(.md-display--div) {
  display: block;
}

:host(.md-display--span) {
  display: inline;
}

.md-typography {
  color: var(--md-typography--default-color);
  font-family: var(--md-typography--font-family);
  font-size: var(--md-typography--font-size);
  font-style: normal;
  font-weight: normal;
  letter-spacing: var(--md-typography--letter-spacing);
  line-height: var(--md-typography--line-height);
  margin: 0;
  padding: 0;
  text-align: start;
  word-break: break-word;
}

.md-typography.is-textdecoration--underline {
  text-decoration: underline;
}

.md-typography.is-textdecoration--line-through {
  text-decoration: line-through;
}

.md-typography.is-textalign--start {
  --md-typography--alignment: start;
  /* justify-content: start; */
  text-align: var(--md-typography--alignment);
}

.md-typography.is-textalign--center {
  --md-typography--alignment: center;
  /* justify-content: center; */
  text-align: var(--md-typography--alignment);
}

.md-typography.is-textalign--left {
  --md-typography--alignment: left;
  /* justify-content: flex-start; */
  text-align: var(--md-typography--alignment);
}

.md-typography.is-textalign--right {
  --md-typography--alignment: right;
  text-align: var(--md-typography--alignment);
}

.md-typography.is-textalign--inherit {
  /* justify-content: inherit; */
  text-align: inherit;
}

.md-typography.is-textalign--initial {
  /* justify-content: initial; */
  text-align: initial;
}

.md-typography.is-nowrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}


:host(.md-responsive) {
  @media screen and (max-width: 767px) {
    --md-font-size--hero1: var(--md-font-size--7xl);
    --md-font-size--hero2: var(--md-font-size--6xl);
    --md-font-size--hero3: var(--md-font-size--5xl);
    --md-font-size--heading1: var(--md-font-size--4xl);
    --md-font-size--heading2: var(--md-font-size--3xl);
    --md-font-size--heading3: var(--md-font-size--2xl);
    --md-font-size--heading4: var(--md-font-size--xl);
    --md-font-size--heading5: var(--md-font-size--lg);
    --md-font-size--heading6: var(--md-font-size--md);
    --md-font-size--heading7: var(--md-font-size--sm);
    --md-font-size--body1: var(--md-font-size--xs);
    --md-font-size--body2: var(--md-font-size--xs);
    --md-font-size--micro1: var(--md-font-size--2xs);
    --md-font-size--micro2: var(--md-font-size--3xs);
  }
}

@import '../../styles/utils/text-color.utils.css';
@import '../../styles/utils/typography-variant.utils.css';
